import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    spinner: {
        position: 'relative',
        left: '50%'
    }
})
export const TableLoadingRow = ({
                                    colSpan
                                }: any) => {
    const classes = useStyles();
    const allColumns = 99;
    return <TableRow>
        <TableCell colSpan={allColumns}>
            <CircularProgress className={classes.spinner} color="inherit"/>
        </TableCell>
    </TableRow>
}
